import {
    WidgetStreamState,
    StreamTimeSeriesState,
} from 'widgets/store/stream/WidgetStreamState';
import { StreamDisableRangeDataState } from 'widgets/store/disableRange/StreamDisableRangeDataState';
import { SessionBoundaryDataTimeSeriesItem } from 'utils/timeseries/TimeSeriesDisableRange';

// State
export type PortfolioPlStreamState = WidgetStreamState<PortfolioPlDataState>;

export interface PortfolioPlDataState
    extends StreamTimeSeriesState<PortfolioPlDataTimeSeriesItem>,
        StreamDisableRangeDataState {}

export interface PortfolioPlDataTimeSeriesItem
    extends SessionBoundaryDataTimeSeriesItem {
    _i: number;
    // *** Performance Chart ***
    // Realized line...
    realizedPnlBuys?: number;
    realizedPnlSells?: number;
    realizedPnlBuysAndSells?: number;
    // Unrealized line...
    unrealizedPnlBuys?: number;
    unrealizedPnlSells?: number;
    unrealizedPnlBuysAndSells?: number;
    // Total line...
    totalPnlBuys?: number;
    totalPnlSells?: number;
    totalPnlBuysAndSells?: number;
    // Index line...
    indexPnl?: number;
    // Sessions
    sessionBoundaryDate?: string;
    sessionBoundaryLabel?: string;

    // Leaves chart
    buyUnrealizedBenchmark?: number;
    sellUnrealizedBenchmark?: number;

    // Percent complete chart
    percentCompleteBuys?: number;
    percentCompleteSells?: number;
    percentCompleteBuysAndSells?: number;

    // Legacy: not used
    _buyCumulativeQuantity?: number;
    _buyRealizedBenchmark?: number;
    _buyRealizedPnl?: number;
    _buyRemainingQuantity?: number;
    _buyUnrealizedPnl?: number;
    _sellCumulativeQuantity?: number;
    _sellRealizedBenchmark?: number;
    _sellRealizedPnl?: number;
    _sellRemainingQuantity?: number;
    _sellUnrealizedPnl?: number;
    _totalRealizedPnl?: number;
    _totalUnrealizedPnl?: number;
    _totalPnl?: number;
}

export const initialPortfolioPlDataState: PortfolioPlDataState = {
    timeSeries: [],
    disableRange: [],
};

export const initialPortfolioPlStreamState: PortfolioPlStreamState = {
    data: initialPortfolioPlDataState,
    messages: [],
};
